import { render, staticRenderFns } from "./setBaseUrl.vue?vue&type=template&id=10428597&"
import script from "./setBaseUrl.vue?vue&type=script&lang=js&"
export * from "./setBaseUrl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports